// props
// fileTypes: []. currently can include "csv" or "excel"
// onSubmit: callback function with args (fileName, data)
// enableMultiSheet: Bool. When validating excels, allows you to upload all sheets

import React from 'react';
import DrcPanel from './DrcPanel';
import DrcButton from './DrcButton';
import DrcFileUpload from './DrcFileUpload';
import { withStyles } from '@material-ui/core/styles';

const extensions = { excel: ['.xlsx', '.xls', '.xlsb'], csv: ['.csv'], pdf: ['.pdf'] };
/**
 *@ignore
 */
const styles = (theme) => ({
    submitBtnContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    submitBtn: {
        width: 150,
        textAlign: 'center'
    }
});

/**
 *
 * @description DrcManagedFileUpload is an input for uploading files, default file types allowed are excel, csv, pdf
 * @example
 * <DrcManagedFileUpload />
 * @category Input
 * @tags input file upload excel
 * @property {*} fileTypes currently can include "csv" or "excel" or "pdf"
 * @property {*} overrideFileTypes can override default file types
 * @property {*} classes custom styles
 * @class DrcManagedFileUpload
 * @extends {React.Component}
 */
class DrcManagedFileUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            typesAllowed: [],
            ableToSubmit: false,
            data: null,
            fileName: ''
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    /**
     *
     * @description Method is called as soon as page is mounted
     * @memberof DrcManagedFileUpload
     */
    componentDidMount() {
        this.buildAllowedTypes();
    }

    /**
     *
     * @description This method is called in componentDidMount to check the fileTypes allowed
     * @memberof DrcManagedFileUpload
     */
    async buildAllowedTypes() {
        var fileTypes = this.props.fileTypes;

        if (fileTypes && this.state.typesAllowed.length < 1) {
            var typesAllowed = [];

            fileTypes.forEach((type) => {
                typesAllowed = typesAllowed.concat(extensions[type]);
            });
            await this.setState({ typesAllowed: [...typesAllowed] });
        }
    }

    /**
     *
     * @description This method is to allow file to be uploaded
     * @param {*} file
     * @memberof DrcManagedFileUpload
     */
    handleFile = (file) => {
        this.setState({
            fileName: file.fileName,
            data: file.data,
            ableToSubmit: true
        });
    };

    /**
     * @description will remove file from uploading
     * @param {*} removeUploadedFile
     * @memberof DrcManagedFileUpload
     */
    removeDrop(removeUploadedFile) {
        this.removeUploadedFile = removeUploadedFile;
    }

    /**
     * @description callback function to submit the uploaded file
     * @memberof DrcManagedFileUpload
     */
    handleSubmit() {
        const state = this.state;
        if (!!this.props.onSubmit) {
            this.props.onSubmit(state.fileName, state.data);
        }
        this.removeUploadedFile();
        this.setState({
            fileName: '',
            data: null,
            ableToSubmit: false
        });
    }

    /**
     * @description function to cancel submitting file
     * @memberof DrcManagedFileUpload
     */
    handleCancel() {
        this.removeUploadedFile();
        this.setState({
            fileName: '',
            data: null,
            ableToSubmit: false
        });
    }

    /**
     * @description Main method to render DrcManagedFileUpload
     * @return {*}
     * @memberof DrcManagedFileUpload
     */
    render() {
        const { classes, overrideFileTypes } = this.props;
        //this.buildAllowedTypes();
        return (
            <React.Fragment>
                <DrcPanel maxWidth={'100%'}>
                    <DrcFileUpload
                        parsed={this.handleFile}
                        removeUpload={this.removeDrop.bind(this)}
                        fileTypeOptions={overrideFileTypes || this.state.typesAllowed}
                        enableMultiSheet={this.props.enableMultiSheet}
                    />
                    <div className={`col-xs-12 ${classes.submitBtnContainer}`}>
                        <DrcButton
                            isPrimary
                            poly
                            noStyle
                            disabled={!this.state.ableToSubmit}
                            className={classes.submitBtn}
                            onClick={this.handleSubmit}
                            //to={this.getReviewLink()}
                        >
                            Submit
                        </DrcButton>
                        <DrcButton isPrimary poly noStyle disabled={!this.state.data} className={classes.submitBtn} onClick={this.handleCancel}>
                            Cancel
                        </DrcButton>
                    </div>
                </DrcPanel>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(DrcManagedFileUpload);
